module.exports = "/assets/data/15e00d5a402535b4877e01c74277a5a3-G53.data.json";